import React from "react";
import { ScrollView } from "react-native";
import { Tab } from "../ui/tab";
import { Id } from "@teachloop/backend/_generated/dataModel";

function ChildrenTabList({
  childList,
  selectedChildId,
  setSelectedChildId,
  noInactiveBorder
}: {
  childList: { _id: Id<"students">; name: string; imageUrl?: string | null }[];
  selectedChildId: Id<"students"> | null;
  setSelectedChildId: (childId: Id<"students"> | null) => void;
  noInactiveBorder?: boolean
}) {
  return (
    <ScrollView contentContainerClassName="gap-1" horizontal showsHorizontalScrollIndicator={false}>
      {childList.map((child) => (
        <Tab
          size="md"
          key={child._id}
          intent={selectedChildId === child._id ? "active" : !noInactiveBorder ? "inActive" : undefined}
          onPress={() => setSelectedChildId(child._id)}
        >
          <Tab.Avatar size="sm">
            <Tab.Avatar.Content
              label={child.name}
              source={child.imageUrl ? { uri: child.imageUrl } : undefined}
              labelSize="sm"
              size="sm"
            />
          </Tab.Avatar>
          <Tab.Text size="md">{child.name}</Tab.Text>
        </Tab>
      ))}
    </ScrollView>
  );
}

export default ChildrenTabList;
